module.exports = __webpack_public_path__ + "img/shcool_card_default.8676956.jpg";